import React, { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import InventoryIcon from '@mui/icons-material/Inventory';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import ReportIcon from '@mui/icons-material/Report';
import { Typography, Box } from '@mui/material';
import { TransportStatus } from 'models/transport';

type TransportStatusIndicatorProps = {
    status?: TransportStatus | string;
    hasProblem: boolean | undefined;
    showText: boolean;
};
const TransportStatusIndicator: FC<TransportStatusIndicatorProps> = ({
    status,
    hasProblem,
    showText,
}: TransportStatusIndicatorProps) => {
    const { t: translate } = useTranslation(['transport']);

    const statusText = () => {
        return translate(`transport:${status}`);
    };

    const statusIcon = () => {
        switch (status) {
            case TransportStatus.PLANNED:
                return <InventoryIcon color="disabled" />;

            case TransportStatus.PICKED_UP:
                return <LocalShippingIcon />;

            case TransportStatus.DELIVERED:
                return <CheckCircleIcon color="success" />;

            case TransportStatus.PRINTED:
                return <CheckCircleIcon color="success" />;

            case TransportStatus.MISSED:
                return <ErrorIcon color="error" />;

            default:
                return <LocalShippingIcon />;
        }
    };

    return (
        <Fragment>
            {hasProblem ? (
                <Box display="flex" alignItems="center">
                    <ReportIcon color="warning" />
                    {showText ? (
                        <Typography variant="subtitle2" color="warning.main" sx={{ marginLeft: 0.5 }}>
                            {translate('transport:UNDER_OBSERVATION')}
                        </Typography>
                    ) : undefined}
                </Box>
            ) : (
                <Box display="flex" alignItems="center">
                    <Box mt="6px">{statusIcon()}</Box>
                    {showText ? (
                        <Box ml={1}>
                            <Typography variant="subtitle2">{statusText()}</Typography>
                        </Box>
                    ) : undefined}
                </Box>
            )}
        </Fragment>
    );
};

export default TransportStatusIndicator;
